import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ComposedChart, Line, ResponsiveContainer } from 'recharts';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

const styles = () => ({
  root: { },
});

const PerformanceChart = ({
  className,
  classes,
  label,
  chartData,
}) => {
  const { logCommentaryEvent } = useManagedAccountPageEventLogger();

  const [performanceData, setPerformanceData] = React.useState([]);

  const mapResourceToChartDataPoint = (r) => {
    return {
      x: (new Date(r.attr('date'))).getTime(),
      y: Number(r.attr('percentageValue')),
    };
  };

  const convertToDataPoints = (perfData) => {
    if (perfData) {
      const perfChartData = perfData.resources().list()
        .slice()
        .reverse()
        .map(mapResourceToChartDataPoint);
      setPerformanceData(perfChartData);
    }
  };

  React.useEffect(() => {
    convertToDataPoints(chartData);
  }, [chartData]);

  if (!chartData) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
      onClick={() => logCommentaryEvent('Performance Chart', {
        name: label,
      })}
    >
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart margin={{
          top: 0, right: 0, bottom: 0, left: 0,
        }}
        >
          <Line
            dataKey="y"
            type="monotone"
            name={'commentary_chart'}
            data={performanceData}
            dot={false}
            activeDot
            stroke="#007098"
            strokeWidth={3}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
};

PerformanceChart.defaultProps = {
  className: '',
};

PerformanceChart.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  chartData: PropTypes.array.isRequired,
};

export default withStyles(styles)(PerformanceChart);
